<template>
  <div class="tw:flex tw:gap-x-2 tw:items-center" v-if="status === null">
    <p class="tw:text-xs">{{ $t('chatbot_feedback_question') }}</p>
    <div class="tw:flex tw:gap-x-2">
      <button
        class="tw:flex tw:p-0 tw:hover:cursor-pointer tw:transition-all tw:duration-200 hover:tw:scale-110 hover:tw:-translate-y-1 active:tw:scale-95"
        @click="handleFeedback(id, 'POSITIVE')"
        :class="{
          'tw:animate-pulse-scale': animatingButton === 'POSITIVE',
        }"
      >
        <ThumbUp />
      </button>
      <button
        class="tw:flex tw:p-0 tw:hover:cursor-pointer tw:transition-all tw:duration-200 hover:tw:scale-110 hover:tw:-translate-y-1 active:tw:scale-95"
        @click="handleFeedback(id, 'NEGATIVE')"
        :class="{
          'tw:animate-pulse-scale': animatingButton === 'NEGATIVE',
        }"
      >
        <ThumbDown />
      </button>
    </div>
  </div>

  <div
    class="tw:flex tw:gap-x-2 tw:items-center tw:animate-in tw:fade-in tw:zoom-in tw:duration-500"
    v-if="status === 'POSITIVE'"
  >
    <p class="tw:text-xs">{{ $t('chatbot_feedback') }}</p>
    <ThumbUpFilled />
  </div>

  <div
    class="tw:flex tw:gap-x-2 tw:items-center tw:mb-2 tw:animate-in tw:fade-in tw:zoom-in tw:duration-500"
    v-if="status === 'NEGATIVE'"
  >
    <p class="tw:text-xs">{{ $t('chatbot_feedback') }}</p>
    <ThumbDownFilled />
  </div>

  <div v-if="status === 'NEGATIVE'">
    <div class="tw:max-w-[275px] tw:mr-auto">
      <i18n-t
        keypath="chatbot_feedback_response"
        tag="p"
        scope="global"
        class="chat-message tw:rounded-xl tw:p-3 tw:wrap-break-word tw:bg-blue-100 tw:text-black"
      >
        <template #HotelierSupportTeam>
          <BaseLink
            :href="supportCenterUrl"
            target="_blank"
            class="tw:cursor-pointer tw:hover:underline tw:text-[revert] tw:text-blue-700 tw:hover:text-blue-700"
          >
            {{ $t('hotelier_support') }}
          </BaseLink>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import ThumbUp from '@/components/icons/ThumbUp.svg?component'
import ThumbDown from '@/components/icons/ThumbDown.svg?component'
import ThumbUpFilled from '@/components/icons/ThumbUpFilled.svg?component'
import ThumbDownFilled from '@/components/icons/ThumbDownFilled.svg?component'
import BaseLink from '@/components/BaseLink.vue'

import useChat from '@/components/chatbot/useChat'
import { getSupportCenterUrl } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'

const { submitFeedback } = useChat()

defineProps({
  id: String,
  status: [String, null],
})
const { language } = useSessionValues()
const supportCenterUrl = computed(() => getSupportCenterUrl(language.value, null, null, false))
const animatingButton = ref(null)

const handleFeedback = (id, feedbackStatus) => {
  animatingButton.value = feedbackStatus
  submitFeedback(id, feedbackStatus)
  setTimeout(() => {
    animatingButton.value = null
  }, 300)
}
</script>
